<div class="d-flex flex-nowrap flex-column flex-sm-row flex-sm-wrap justify-content-center align-items-center m-0 py-3">

  <div *ngFor="let pointer of controlPointer; let i = index" class="d-flex flex-sm-column flex-row container-info">



    <div class="d-flex align-items-center py-2 card-container">
      <div class="flip-card">
        <div class="flip-card-inner">
          <div class="flip-card-front" [style.background]="pointer.background ?? '#36858a94'">
            <div class="info-container">
              <h4 class="m-0">{{i == 0 ? 'Punto origen' : i == controlPointer.length - 1 ? 'Punto Fin' : i}}</h4>
            </div>
          </div>

          <div class="flip-card-back" [style.background]="pointer.background ?? '#36858a94'">

            <div *ngIf="pointer.buttonsType?.includes(1)" (click)='$selectPointer(i, pointer)' matTooltip="Registrar"
              matTooltipPosition="above">
              <i class="fa fa-plus-square btn-accion" style="cursor: pointer; font-size: 20px"></i>
            </div>

            <div *ngIf="pointer.buttonsType?.includes(2)" (click)='editCard(pointer)' matTooltip="Editar"
              matTooltipPosition="above">
              <i class="fa fa-edit btn-accion" style="cursor: pointer; font-size: 20px;"></i>
            </div>

            <div *ngIf="pointer.buttonsType?.includes(3)" (click)='deleteCard(i, pointer)' matTooltip="Eliminar"
              matTooltipPosition="above">
              <i class="fa fa-trash btn-accion" style="cursor: pointer; font-size: 20px"></i>
            </div>

            <div *ngIf="pointer.buttonsType?.includes(4) && pointer.background != '#d18888'" (click)='viewDetail(i, pointer)' matTooltip="Detalle"
              matTooltipPosition="above">
              <i class="fa fa-eye btn-accion" style="cursor: pointer; font-size: 20px"></i>
            </div>

          </div>
        </div>

        <div class="d-sm-none d-flex flex-column" *ngIf="i != controlPointer.length - 1">
          <div [ngClass]="{'linea-vertical-complete': controlPointer[i+1]?.complete || isHistorical, 'linea-vertical': !controlPointer[i+1]?.complete}"></div>
          <div *ngIf="viewAddCkeckpoint && !controlPointer[i+1].complete" class="d-flex justify-content-center align-items-center">
            <button
              mat-mini-fab
              color="primary"
              (click)="addCheckpointDialog(i)"
              matTooltip="Punto de control intermedio"
              style="width: 30px; height: 30px; min-width: 30px;"
            >
              <mat-icon style="font-size: 16px;">add_location_alt</mat-icon>
            </button>
          </div>
          <div [ngClass]="{'linea-vertical-complete': controlPointer[i+1]?.complete || isHistorical, 'linea-vertical': !controlPointer[i+1]?.complete}"></div>          
        </div>

      </div>


      <div
        class="d-none d-sm-flex align-items-sm-center"
        *ngIf="i != controlPointer.length - 1"
      >
        <div class="line"></div>
        <div *ngIf="viewAddCkeckpoint && !controlPointer[i+1].background" class="d-flex justify-content-center align-items-center">
          <button
            mat-mini-fab
            color="primary"
            (click)="addCheckpointDialog(i)"
            matTooltip="Punto de control intermedio"
          >
            <mat-icon>add_location_alt</mat-icon>
          </button>
        </div>

        <div class="line"></div>
      </div>
    </div>

    <div class="description-container d-flex">
      <div class="description">
        <h5 class="m-0 text-center">{{pointer.date | dateFormat}}</h5>
        <h3 class="m-0">{{pointer.name}}</h3>
      </div>
    </div>
   

  </div>

</div>

<div *ngIf="!isRoute" class="color-code-container">
  <div class="color-code">
    <span class="color-box" [style.background]="colorComplete"></span>
    <span>Completo</span>
  </div>
  <div class="color-code">
    <span class="color-box" [style.background]="colorIncomplete"></span>
    <span>Incompleto</span>
  </div>
  <div *ngIf="!isHistorical" class="color-code">
    <span class="color-box" [style.background]="colorPending"></span>
    <span>Pendiente</span>
  </div>
</div>
